// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sigwx-hazard-symbols.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sigwx-hazard-symbols/sigwx-hazard-symbols.js';
import g1 from '../lessons/meteorology/sigwx-hazard-symbols/sigwx-jet-turbulence-tropopause.js';

mount([g0, g1]);
